import { render, staticRenderFns } from "./ButtonMobile.vue?vue&type=template&id=9ef5dee4&scoped=true&"
import script from "./ButtonMobile.vue?vue&type=script&lang=js&"
export * from "./ButtonMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef5dee4",
  null
  
)

export default component.exports